<template>
  <div ref='input_tree' class="input_tree" :id='"id"+refresh'>
    <el-input :clearable="clearable" :placeholder="placeholder" v-model="input.value" @focus="setShowPop" @clear="clearVal" ref="input_tree_input" :disabled="disabled"></el-input>
    <div class="el-select" :class="{'is-disabled': disabled}" @click="setFocus" v-if="input_tree_select">
      <div class="el-select-inner">
        <el-tag v-for="(i,index) in select" :key="i.id" closable @close="handleClose(i)" size="small" type="info">{{i.value}}</el-tag>
      </div>
      <!-- <span v-if="isLineMore" class="tags">...</span> -->
      <el-popover v-if="isLineMore && select.length"
        placement="top"
        width="400"
        trigger="hover">
        <div class="tree_popover_tags">
          <el-tag v-for="(i,index) in select" :key="i.id" closable @close="handleClose(i)" size="small" type="info">{{i.value}}</el-tag>
        </div>
        <span slot="reference" class="tags">...</span>
      </el-popover>

    </div>
    <div :id='"idb"+refresh' class="tree_bg" v-if="showPop" :style="'max-width:'+maxWidth+'px'">
      <!-- <div class="tree_bg_bg" @click="showPop = false"></div> -->
      <el-input placeholder="筛选" v-model="inputSearch"></el-input>
      <span class="search_ico el-icon-search" @click="screenTree"></span>
      <div style="color:#666;margin-top:5px;" v-if="isShowBtn" @click="expandFn"><i :class="expand ? 'fa fa-minus-square-o' : 'fa fa-plus-square-o'" aria-hidden="true"></i><span style="cursor: pointer;margin-left:5px;">全部{{expandHint}}</span></div>
      <el-tree class="filter-tree" :data="data" :props="defaultProps" :default-expand-all="expand" :highlight-current="true" :filter-node-method="filterNode" :style="'max-height:'+maxHeight+'px'"
        @node-click="handleNodeClick" @check-change="handleCheckChange" :default-checked-keys="select.map(c=>{return c.id})" :show-checkbox="multi" node-key="id" ref="tree" :key="expandRe">
      </el-tree>
    </div>

  </div>
</template>

<script>
  export default {
    name: "input_tree",
    components: {},
    data() {
      return {
        showPop: false,
        // inputText: '',
        inputSearch: "",
        input: {
          id: "",
          value: ""
        },
        select: [],
        input_tree_select: true,
        //查看按钮右边距
        isLineMore: false,
        marginRight: 0,
        refresh: (() => {
          return (Math.random() + "").replace(".", "");
        })(),
        maxWidth:0,
        maxHeight:0,
        expand:true,
        expandHint:'收起',
        expandRe:1
      };
    },
    props: {
      data: {
        type: Array,
        default () {
          return [];
        }
      },
      multi: {
        type: Boolean,
        default: false
      },
      checked: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      label: String,
      chooseobj: Object,
      choosearr: {
        type: Array,
        default () {
          return [];
        }
      },
      childrenFlag: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择组织机构'
      },
      clearable: {
        type: Boolean,
        default: true
      },
      defaultProps: {
        type:Object,
        default:{
          children: "children",
          label: "label"
        }
      },
      isShowBtn:{//是否显示收起与展开按钮
        type:Boolean,
        default:true
      }
    },
    watch: {
      inputSearch(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
     
      expandFn(){
       this.expand = !this.expand
       this.expandHint = this.expand ? '收起' : '展开'
       this.expandRe = Math.random()
      },
      screenTree(){
        this.$refs.tree.filter(this.inputSearch);
      },
      resizeTree(){//计算弹框距离底部与右边的距离
          let left = parseInt($("#id"+this.refresh).offset().left)
          let winWidth = parseInt($(window).width())
          let top = parseInt($("#id"+this.refresh).offset().top)
          let winHeight = parseInt($(window).height())
          let right = winWidth - left - 30
          let bottom = winHeight - top - 160
          this.maxWidth = right
          this.maxHeight = bottom
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      setShowPop() {
        let vm = this;
        // console.log("==============")
        if (vm.disabled) return;
        vm.showPop = true;
        vm.resizeTree()
        vm.$nextTick(function () {
          document.addEventListener('click', vm.fnEventListener)
          vm.$refs.tree.filter(vm.inputSearch);
        })

        if (!vm.multi && vm.chooseobj) {
          //单选
          vm.$nextTick(function () {
            vm.$refs.tree.setCurrentNode(vm.chooseobj);
          });
        }
      },
      //单选
      handleNodeClick(data) {
        let vm = this;
        if (!this.multi) {
          if (this.childrenFlag && data.children && data.children.length > 1) {
            return this.$message.warning("不能选择该节点！");
          }
          this.input = {
            id: data.id,
            value: vm.label ? data[vm.label] : data.label,
          };

          data.value = data.label;

          this.$emit("treeFn", data);
          this.$emit('chooseobj', data);
          this.$set(this, "showPop", false);
        }
      },
      //单选
      fnSetCurrentKey() {
        let vm = this;
        vm.input = {
          id: vm.chooseobj.id,
          // value: vm.chooseobj.label
          value: vm.label ? vm.chooseobj[vm.label] : vm.chooseobj.label,
        };
        // this.$emit('treeFn', vm.input)
        // if(this.showPop){
        //   vm.$refs.tree.setCurrentNode(vm.toChoose[0]);       //通过 key 设置
        //   // let node = vm.$refs.tree.getCurrentNode()
        // }
      },
      //多选
      fnSetCheckedKeys() {
        let vm = this;
        _.forEach(vm.choosearr, (ss, i) => {
          vm.select.push({
            id: ss.id,
            value: ss.label
          });
        });

        if(vm.select.length){
          this.input.value = " ";
        }else{
          this.input.value = "";
        }
        this.$nextTick(_=>{
          let $0 = document.querySelector("#id" + this.refresh);
          let sWidth = $0.querySelectorAll(".el-select")[0].offsetWidth;
          let innerWidth = $0.querySelectorAll(".el-select-inner")[0].offsetWidth;
          vm.isLineMore = sWidth < innerWidth;
          // console.log(sWidth,innerWidth)
        })

        // if(this.showPop){
        //   vm.$refs.tree.setCheckedNodes(vm.choosearr);       //通过 key 设置
        // }
        // vm.$emit('treeFn', vm.select)
      },
      handleCheckChange(data, checked, indeterminate) {
        let vm = this;
        //多选
        if (vm.multi) {
          let arr = [];
          vm.input.value = " ";
          let arr2 = [];
          _.forEach(vm.$refs.tree.getCheckedNodes(), (ss, i) => {
            arr.push({
              id: ss.id,
              value: ss.label
            });
            ss.value = ss.label;
            arr2.push(ss)
          });
          vm.select = arr;
          // console.log(vm.select);
          // vm.choosearr = arr;
          vm.$emit("treeFn", arr2);
          // vm.$emit('choosearr', vm.select);
          if (!vm.select.length) {
            vm.input.value = "";
            vm.isLineMore = false;
          }
          // let $0 = document.querySelector("#id" + this.refresh);
          // let lastItem = $0.querySelectorAll(".el-tag")[
          // $0.querySelectorAll(".el-tag").length - 1
          //   ];
          // if (!lastItem) {
          //   return;
          // }
          // this.isLineMore = $(lastItem).position().left > 5;
          setTimeout(() => {
          //   this.setView();
          // vm.$nextTick(_=>{
            // console.log(vm.select);
            let $0 = document.querySelector("#id" + this.refresh);
            let sWidth = $0.querySelectorAll(".el-select")[0].offsetWidth;
            let innerWidth = $0.querySelectorAll(".el-select-inner")[0].offsetWidth;
            // console.log(sWidth,innerWidth)
            vm.isLineMore = sWidth < innerWidth;
          // })

          }, 350);
          
        }
      },
      resetChecked() {
        this.$refs.tree.setCheckedKeys([]);
      },
      setView() {
        if (this.multi && this.choosearr) {
          //多选
          this.fnSetCheckedKeys();
        } else if (!this.multi && this.chooseobj) {
          //单选
          this.fnSetCurrentKey();
        }
        // let $0 = document.querySelector("#id" + this.refresh);
        // let lastItem = $0.querySelectorAll(".el-tag")[
        //   $0.querySelectorAll(".el-tag").length - 1
        // ];
        // if (!lastItem) {
        //   return;
        // }
        // this.isLineMore = $(lastItem).position().top > 5;
        // // this.marginRight = this.$refs.input_tree.offsetWidth % 72
      },
      fnEventListener($event) {
        let vm = this;
        // let $0 = document.querySelector("#idb" + vm.refresh)
        let $1 = document.querySelector("#id" + vm.refresh)
        let hasId = false;
        _.each($event.path, i => {
          if ($1 && i.id == $1.id) {
            hasId = true;
            return;
          }
        })
        if (!hasId) {
          vm.showPop = false;
          document.removeEventListener('click', vm.fnEventListener);
        }
      },
      setFocus() {
        let vm = this;
        if (vm.disabled) return;
        vm.$refs.input_tree_input.focus();
        vm.showPop = true;
        vm.$nextTick(function () {
          document.addEventListener('click', vm.fnEventListener)
        })
      },
      clearVal(){
          this.showPop = false
          this.$emit("treeFn", '');
          this.$emit('chooseobj', '');
          this.$set(this, "showPop", false);
      },
      handleClose(obj){
        let vm = this;
        // console.log(obj.id,vm.select);
        let oldSelect = _.cloneDeep(vm.select);
        let newSelect = _.remove(oldSelect,s=>{
          if(s.id == obj.id){
            return s;
          }
        })
        vm.select = oldSelect;
        vm.$refs.tree.setCheckedNodes(vm.select);

        if(vm.select.length){
          this.input.value = " ";
        }else{
          this.input.value = "";
        }
        
      }
    },
    mounted() {
      let vm = this
      if (!("path" in Event.prototype))
        Object.defineProperty(Event.prototype, "path", {
          get: function () {
            var path = [];
            var currentElem = this.target;
            while (currentElem) {
              path.push(currentElem);
              currentElem = currentElem.parentElement;
            }
            if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
              path.push(document);
            if (path.indexOf(window) === -1)
              path.push(window);
            return path;
          }
        });


      if (!this.multi) {
        this.input_tree_select = false;
      }

      setTimeout(() => {
        this.setView();
      }, 350);

      window.onresize = function(){
          vm.resizeTree()
      }

    }
  };
</script>

<style lang="less" scoped>
  .el-form .input_tree {
    display: block;
  }

  .el-form.el-form--inline .input_tree {
    display: inline-block;
  }

  .el-form.el-form--inline .input_tree .tree_bg .el-input {
    width: 100%;
  }

  .input_tree {
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 100%;
    .el-select {
      position: absolute;
      left: 1px;
      top: 0;
      right:1px;
      height: 34px;
      padding: 3px 0;
      width:99%;
      box-sizing: border-box;
      overflow: hidden;
      white-space: nowrap;
      .el-select-inner {display: inline-block;}
      &.is-disabled {
        &.is-disabled:hover,
        &.is-disabled:hover .el-tag {
          cursor: not-allowed;
        }
        .tags {
          background: #f5f7fa;
        }
      }
    }
    .tags {
      position: absolute;
      top: 4px;
      bottom: 1px;
      right: 0px;
      background: #fff;
      padding: 3px;
      border-radius: 0 4px 4px 0;
      cursor: pointer;
      width:20px;
    }
    .el-tag {
      cursor: default;
      vertical-align: top;
      margin:5px 0 2px 6px;
    }


  }

  .tree_bg {
    display: block;
    position: absolute;
    z-index: 1000;
    top: 36px;
    left: 0;
    min-width: 100%;
    padding: 12px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: #fff;
    z-index: 111;
    box-sizing: border-box;
    border: 1px solid #e6ebf5;
    .tree_bg_bg {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
    }
    .el-tree {
      /* max-height: 280px; */
      overflow: auto;
      margin: 5px -12px -12px 0;
      // padding-top: 6px;
    }
  }
  .search_ico{
    height: 34px;
    width: 34px;
    line-height: 34px;
    text-align: center;
    position: absolute;top: 12px;right:12px;
    cursor: pointer;
  }
</style>
<style lang="less">
  .tree_bg .el-tree-node>.el-tree-node__children {
    overflow: initial;
  }
  .tree_bg .el-tree-node__content{
    padding-right: 70px;
    box-sizing: border-box;
    
  }

  .tree_popover_tags {
    .el-tag {
      cursor: default;
      margin:2px 3px 2px 3px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/commonplugin/input_tree.vue